// GENERATED from accounting-backend/commercial/shared/bundleLogic.js; do not edit.
// Canonical implementation. Browser modules are generated by export-definitions.
// These helpers author concrete drafts and describe terms; they never authorize runtime access.

function validateBundles(config, definitions) {
    const implemented = definitions.filter(d => d.kind === 'feature' && d.status !== 'legacy').map(d => d.key);
    const keys = config.groups.flatMap(group => group.keys);
    if (new Set(keys).size !== keys.length || keys.length !== implemented.length || keys.some(key => !implemented.includes(key)))
        throw new Error('Every implemented capability needs exactly one bundle assignment');
    if (new Set(config.groups.map(group => group.id)).size !== config.groups.length) throw new Error('Duplicate bundle identity');
    for (const group of config.groups) if (!group.names.sv || !group.names.en || !group.keys.length) throw new Error('Invalid bundle presentation');
    if (new Set(config.cardOrder).size !== config.cardOrder.length || config.cardOrder.some(id => !config.groups.some(group => group.id === id))) throw new Error('Invalid card display order');
    if (config.hiddenFeatures.some(key => !keys.includes(key))) throw new Error('Unknown hidden capability');
}

function visibleDefinitions(config, definitions) {
    return definitions.filter(d => d.kind === 'feature' && d.status !== 'legacy' && !config.hiddenFeatures.includes(d.key));
}
function moduleIncluded(features, offer) {
    const entries = Object.entries(offer.payload.features).filter(([,value]) => value === true);
    return offer.kind === 'module' && entries.length > 0 && Object.keys(offer.payload.limits || {}).length === 0 && entries.every(([key]) => features[key] === true);
}
function availableModule(config, offers, features, keys, cycle, definitions) {
    return offers.find(offer => offer.kind === 'module' && !config.hiddenOffers.includes(offer.code)
        && keys.every(key => features[key] === true || offer.payload.features[key] === true)
        && (offer.prices || []).some(price => price.billingCycle === cycle)
        && definitions.every(d => !(features[d.key] || offer.payload.features[d.key])
            || (d.requires || []).every(key => features[key] || offer.payload.features[key])));
}
function featureStatus(config, features, key, offers, cycle, definitions) {
    if (features[key] === true) return 'included';
    return availableModule(config, offers, features, [key], cycle, definitions) ? 'addon' : 'unavailable';
}
function featureDetails(config, features, definitions, offers = [], cycle = 'monthly', locale = 'sv') {
    return visibleDefinitions(config, definitions).map(d => ({id:d.key, keys:[d.key], label:d.names[locale],
        status:featureStatus(config, features, d.key, offers, cycle, definitions)}));
}
function groupRows(config, features, definitions, offers = [], cycle = 'monthly', locale = 'sv') {
    const details = featureDetails(config, features, definitions, offers, cycle, locale);
    return config.groups.filter(group => !group.hidden).flatMap(group => {
        const members = group.keys.map(key => details.find(row => row.id === key)).filter(Boolean);
        if (!members.length) return [];
        const statuses = new Set(members.map(row => row.status));
        // A mixed group retains its individual details. A single add-on claim
        // must be backed by one purchasable package with satisfied prerequisites.
        const status = statuses.size === 1 ? members[0].status : 'partial';
        const keys = members.flatMap(row => row.keys);
        const offer = status === 'addon' ? availableModule(config, offers, features, keys, cycle, definitions) : null;
        return [{id:group.id, keys, label:group.names[locale], status:status === 'addon' && !offer ? 'partial' : status,
            details:members, offerCode:offer?.code || null,
            price:offer?.prices.find(price => price.billingCycle === cycle) || null}];
    });
}
function capacityRows(config, features, limits, definitions, locale = 'sv') {
    return definitions.filter(d => d.kind === 'capacity' && d.status !== 'legacy').map(d => {
        const quantity = limits[d.key];
        const prerequisite = config.capacityPrerequisites[d.key];
        const required = prerequisite && features[prerequisite] !== true;
        const label = definitions.find(item => item.key === prerequisite)?.names[locale];
        const value = quantity === undefined ? '—' : quantity === null ? (locale === 'sv' ? 'Obegränsat' : 'Unlimited') : `${quantity}${d.unit === 'GB' ? ' GB' : ''}`;
        return {key:d.key, label:d.names[locale], quantity, value:value + (required ? ` (${locale === 'sv' ? 'kräver' : 'requires'} ${label})` : '')};
    });
}
function cardRows(config, rows) {
    const included = rows.filter(row => row.status === 'included');
    const order = config.cardOrder;
    const ordered = [...order.flatMap(id => included.filter(row => row.id === id)), ...included.filter(row => !order.includes(row.id))];
    return ordered.slice(0, 7);
}

// A toggle changes only the selected bundle's keys. Partial/customized rights in
// other bundles and unknown historical values survive. Shared prerequisites are
// retained when another selected capability depends on them.
function setBundle(config, payload, keys, enabled, definitions, modules = []) {
    const features = {...payload.features};
    for (const key of keys) features[key] = enabled;
    if (!enabled) {
        let changed;
        do {
            changed = false;
            for (const d of definitions) if (features[d.key] === true) for (const required of d.requires || []) {
                if (keys.includes(required) && !features[required]) { features[required] = true; changed = true; }
            }
        } while (changed);
    } else {
        let changed;
        do {
            changed = false;
            for (const d of definitions) if (features[d.key] === true) for (const required of d.requires || []) {
                if (!features[required]) { features[required] = true; changed = true; }
            }
        } while (changed);
    }
    const known = new Set(modules.map(offer => offer.code));
    const includedModules = [...(payload.includedModules || []).filter(code => !known.has(code)),
        ...modules.filter(offer => moduleIncluded(features, offer)).map(offer => offer.code)];
    return {...payload, features, includedModules:[...new Set(includedModules)].sort()};
}
function bundleState(features, keys) {
    const count = keys.filter(key => features[key] === true).length;
    return count === keys.length ? 'included' : count ? 'partial' : 'unavailable';
}

export {validateBundles, visibleDefinitions, moduleIncluded, featureStatus, featureDetails, groupRows, capacityRows, cardRows, setBundle, bundleState};
